import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar Balanço", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Salvar alterações", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Iniciar balanço", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { style: {"padding":"20px 0px 10px 0px"} }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_status_balanco_estoque = _resolveComponent("selecionar-status-balanco-estoque")!
  const _component_card = _resolveComponent("card")!
  const _component_balanco_estoque_itens = _resolveComponent("balanco-estoque-itens")!
  const _component_balanco_estoque_revisao = _resolveComponent("balanco-estoque-revisao")!
  const _component_balanco_estoque_finalizacao = _resolveComponent("balanco-estoque-finalizacao")!
  const _component_balanco_estoque_resumo = _resolveComponent("balanco-estoque-resumo")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "100%",
      "wrap-class-name": "scroll-modal ss-modal-estoques",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      title: "Balanço de Estoque"
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.state.balancoEstoque.status !== _ctx.EStatusBalancoEstoque.Cancelado && _ctx.state.balancoEstoque.codigo > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelar()))
              }, _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.state.balancoEstoque.codigo > 0 && _ctx.state.salvarAlteracoes)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar()))
              }, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.state.balancoEstoque.codigo === 0 && _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar()))
              }, _hoisted_6))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_a_alert, {
              message: "Dica importante",
              description: "Antes de iniciar o balanço tenha certeza que os produtos que serão contados estão bloqueados ou evite movimentar os mesmos enquanto não concluir o balanço.",
              type: "info",
              "show-icon": ""
            }, null, 512), [
              [_vShow, _ctx.state.balancoEstoque.codigo === 0]
            ]),
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_steps, {
                    "progress-dot": "",
                    current: _ctx.state.passo,
                    "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.passo) = $event)),
                    direction: "horizontal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_step, {
                        key: "0",
                        title: "Dados Principais"
                      }),
                      _withDirectives(_createVNode(_component_a_step, {
                        key: "1",
                        title: "Produtos/Contagens"
                      }, null, 512), [
                        [_vShow, _ctx.state.balancoEstoque.status === _ctx.EStatusBalancoEstoque.Aberto]
                      ]),
                      _withDirectives(_createVNode(_component_a_step, {
                        key: "2",
                        title: "Revisão"
                      }, null, 512), [
                        [_vShow, _ctx.verificaApresentacaoRevisao()]
                      ]),
                      _withDirectives(_createVNode(_component_a_step, {
                        key: "3",
                        title: "Finalizar"
                      }, null, 512), [
                        [_vShow, _ctx.verificaApresentacaoFinalizar()]
                      ]),
                      _withDirectives(_createVNode(_component_a_step, {
                        key: "4",
                        title: "Resumo"
                      }, null, 512), [
                        [_vShow, _ctx.state.balancoEstoque.status === _ctx.EStatusBalancoEstoque.Finalizado]
                      ])
                    ]),
                    _: 1
                  }, 8, ["current"])
                ], 512), [
                  [_vShow, _ctx.state.balancoEstoque.codigo > 0]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(_ctx.state.balancoEstoque.status === _ctx.EStatusBalancoEstoque.Aberto?'':'ss-bloquear-tela')
                }, [
                  _createVNode(_component_card, { titulo: " " }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_form_item, {
                            label: "Empresa",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_empresa, {
                                codigoSelecionado: _ctx.state.balancoEstoque.codigoEmpresa,
                                "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.balancoEstoque.codigoEmpresa) = $event)),
                                disabled: (_ctx.state.balancoEstoque.codigo > 0)
                              }, null, 8, ["codigoSelecionado", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Responsável",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_usuario, {
                                codigoSelecionado: _ctx.state.balancoEstoque.codigoUsuario,
                                "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.balancoEstoque.codigoUsuario) = $event)),
                                empresas: [_ctx.state.balancoEstoque.codigoEmpresa],
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.salvarAlteracoes = true))
                              }, null, 8, ["codigoSelecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: "N.Balanço",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.balancoEstoque.codigo) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.state.balancoEstoque.codigo]
                              ])
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.state.balancoEstoque.codigo > 0]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.state.balancoEstoque.codigo > 0?'ant-col ant-col-xs-24 ant-col-xl-20':'ant-col ant-col-xs-24 ant-col-xl-24')
                        }, [
                          _createVNode(_component_a_form_item, {
                            label: "Descrição",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "255",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.balancoEstoque.descricao) = $event)),
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.salvarAlteracoes = true))
                              }, null, 544), [
                                [_vModelText, _ctx.state.balancoEstoque.descricao]
                              ])
                            ]),
                            _: 1
                          })
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_form_item, {
                            label: "Data Início",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.state.balancoEstoque.dataInicio,
                                "onUpdate:dataSelecionada": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.balancoEstoque.dataInicio) = $event)),
                                horaMinutoSegundo: true,
                                placeholder: "",
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.salvarAlteracoes = true))
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_a_form_item, {
                            label: "Previsão de conclusão",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.state.balancoEstoque.dataPrevisaoConclusao,
                                "onUpdate:dataSelecionada": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.balancoEstoque.dataPrevisaoConclusao) = $event)),
                                horaMinutoSegundo: true,
                                placeholder: "",
                                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.salvarAlteracoes = true))
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_form_item, {
                            label: "Data Fim",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.state.balancoEstoque.dataFim,
                                "onUpdate:dataSelecionada": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.balancoEstoque.dataFim) = $event)),
                                horaMinutoSegundo: true,
                                placeholder: "",
                                disabled: true
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.state.balancoEstoque.status === _ctx.EStatusBalancoEstoque.Finalizado]
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, {
                            label: "Status",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_status_balanco_estoque, {
                                codigoSelecionado: _ctx.state.balancoEstoque.status,
                                "onUpdate:codigoSelecionado": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.balancoEstoque.status) = $event)),
                                disabled: true
                              }, null, 8, ["codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.state.balancoEstoque.status === _ctx.EStatusBalancoEstoque.Finalizado?'ant-col ant-col-xs-24 ant-col-xl-8':'ant-col ant-col-xs-24 ant-col-xl-12')
                        }, [
                          _createVNode(_component_a_form_item, {
                            label: "Quantidade conferentes",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.balancoEstoque.quantidadeConferentes) = $event)),
                                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.prepararConferentes()))
                              }, null, 544), [
                                [_vModelText, _ctx.state.balancoEstoque.quantidadeConferentes]
                              ])
                            ]),
                            _: 1
                          })
                        ], 2)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, { titulo: "CONFERENTES" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.balancoEstoque.conferentes, (conferente, index) => {
                            return (_openBlock(), _createBlock(_component_a_form_item, {
                              key: index,
                              label: (index + 1) + 'º Conferente',
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_usuario, {
                                  codigoSelecionado: conferente.codigoUsuario,
                                  "onUpdate:codigoSelecionado": ($event: any) => ((conferente.codigoUsuario) = $event),
                                  empresas: [_ctx.state.balancoEstoque.codigoEmpresa]
                                }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas"])
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ], 2), [
                  [_vShow, _ctx.state.passo === 0]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_card, { titulo: " " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_balanco_estoque_itens, {
                        codigoBalancoEstoque: _ctx.state.balancoEstoque.codigo,
                        codigoResponsavel: _ctx.state.balancoEstoque.codigoUsuario,
                        conferentes: _ctx.state.balancoEstoque.conferentes,
                        codigoEmpresa: _ctx.state.balancoEstoque.codigoEmpresa,
                        onAtualizarRevisao: _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.atualizarDadosRevisao = true))
                      }, null, 8, ["codigoBalancoEstoque", "codigoResponsavel", "conferentes", "codigoEmpresa"])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.state.passo === 1]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_card, { titulo: " " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_balanco_estoque_revisao, {
                        ref: "refBalancoEstoqueRevisao",
                        codigoBalancoEstoque: _ctx.state.balancoEstoque.codigo,
                        codigoResponsavel: _ctx.state.balancoEstoque.codigoUsuario,
                        conferentes: _ctx.state.balancoEstoque.conferentes,
                        codigoEmpresa: _ctx.state.balancoEstoque.codigoEmpresa,
                        onRevisaoConcluida: _cache[19] || (_cache[19] = ($event: any) => (_ctx.atualizarDadosRevisao()))
                      }, null, 8, ["codigoBalancoEstoque", "codigoResponsavel", "conferentes", "codigoEmpresa"])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.state.passo === 2]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_card, { titulo: " " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_balanco_estoque_finalizacao, {
                        codigoBalancoEstoque: _ctx.state.balancoEstoque.codigo,
                        statusBalancoEstoque: _ctx.state.balancoEstoque.status,
                        onBalancoFinalizado: _cache[20] || (_cache[20] = ($event: any) => (_ctx.balancoFinalizado()))
                      }, null, 8, ["codigoBalancoEstoque", "statusBalancoEstoque"])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.state.passo === 3]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_card, { titulo: " " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_balanco_estoque_resumo, {
                        ref: "refBalancoEstoqueResumo",
                        codigoBalancoEstoque: _ctx.state.balancoEstoque.codigo,
                        codigoEmpresa: _ctx.state.balancoEstoque.codigoEmpresa
                      }, null, 8, ["codigoBalancoEstoque", "codigoEmpresa"])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.state.passo === 4]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}